import { Pipe, PipeTransform } from '@angular/core';
import { get } from 'lodash';
import { KeysOfType } from '@zaoblako/web/core/types/keys-of.type';

@Pipe({
  standalone: true,
  name: 'sum'
})
export class SumPipe implements PipeTransform {
  public transform<T>(array: T[], key: KeysOfType<T, number> | string, withRate: boolean = false): number {
    if (!Array.isArray(array)) {
      return 0;
    }
    return array.reduce(
      (sum, item) => sum + +(get(item, key as string) ?? 0) * (withRate ? +get(item, 'rate') : 1),
      0
    );
  }
}
